export const formatPastedJavascriptTags = string => {
  // When the Javascript tag is pasted into the field, after the first <ins add:
  // data-dcm-click-tracker='${CLICK_URL}'

  // eslint-disable-next-line
  const jsTag = "data-dcm-click-tracker='${CLICK_URL}'"

  if (string.includes('<ins') && !string.includes(jsTag)) {
    return string.replace('<ins', `<ins ${jsTag} `)
  } else {
    return string
  }
}
